// extracted by mini-css-extract-plugin
export default {"container":"Root_container__NeUXu","decor":"Root_decor__BZo-k","main":"Root_main__25U35"};